/* eslint-disable indent, no-param-reassign,no-plusplus, no-unused-vars */
import axios from 'axios';
import cacheAxios from '../../util/cacheAxios';

const institutionAxios = axios.create();
const cache = new Map();
cacheAxios(institutionAxios, cache);
institutionAxios.interceptors.response.use(response => response,
  (error) => {
    if (error && error.response && error.response.status === 401) {
      setTimeout(() => {
        window.location.href = '/sign/in?source=/aims';
      }, 500);
    }
  });

export default {
  state: {
    institutionIndexes: [],
    note: '',
  },
  mutations: {
    setInstitutionIndexes(state, indexes) {
      state.institutionIndexes = indexes;
    },
    setInstitutionNote(state, note) {
      state.note = note;
    },
  },
  actions: {
    getAllInstitutionalIndexes({
      commit,
    }) {
      institutionAxios.get('/aims/api/companyIndexes/institutionIndexes')
        .then(res => commit('setInstitutionIndexes', res.data));
      // .catch(e => console.log(e));
    },
    getInstitutionNote({
      commit,
      rootState,
    }) {
      institutionAxios.get(`/aims/api/notes/${rootState.currentUser.userid}/InstitutionMatrix`)
        .then(res => commit('setInstitutionNote', res.data.note));
    },
    saveInstitutionNote({
      commit,
      rootState,
    }, text) {
      const note = {
        module: 'InstitutionMatrix',
        userid: rootState.currentUser.userid,
        note: text,
      };
      institutionAxios.post('/aims/api/notes', note)
        .then(res => commit('setInstitutionNote', note.note));
    },
  },
  getters: {
    // continents(state) {
    //   return Object.keys(groupBy(state.countryInfos, 'continent'));
    // },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/institutionModule.js